import React, { useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { expiredAction } from '../store/actions/expiredAction';
import toggleRegisterForm from '../store/actions/registerFormToggle';
import { logout } from '../store/actions/user';

function ExpiredModal() {
  const { translations } = useSelector((state) => state.translation);
  const dispatch = useDispatch();
  const { isExpired } = useSelector((state) => state.expiredReducer);
  const lang = Cookies.get('i18next') || 'en';
  useEffect(() => {
    if (isExpired) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isExpired]);
  const handleLoginAgain = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('UserBasket');
    dispatch(toggleRegisterForm({ visible: true, type: 'login' }));
    dispatch(expiredAction(false));
  };
  return (
    <Dialog
      dismissableMask
      closeOnEscape
      draggable={false}
      className="register-modal expired-modal"
      headerClassName="expired-modal-header"
      maskStyle={{
        background: 'rgba(0, 0, 0, 0.60)',
        width: '100%',
      }}
      visible={isExpired}
      onHide={() => {
        dispatch(logout());
        window.location.href = `/${lang}`;
      }}
    >
      <div className="expired-modal-content">
        <p className="expired-modal-text">
          {translations?.unAuth1?.[lang]}
          <button onClick={handleLoginAgain} type="button">{translations?.unAuth2?.[lang]}</button>
          {translations?.unAuth3?.[lang]}
        </p>
      </div>
    </Dialog>
  );
}

export default ExpiredModal;
